// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  SiteUpdate
}                         from '../../components';

class Site extends PureComponent {
  

  render() {
    return(
      <AnimatedView>
              
        <div className="row">
          <div className="col-md-12">
          <h1> Welcome to site </h1>
            {/* <SiteUpdate /> */}
          </div>
        </div>

        
      </AnimatedView>
    );
  }
}

export default Site;



// WEBPACK FOOTER //
// ./src/app/views/site/Site.js